module.exports = __webpack_public_path__ + "img/sured.fbeb0fc.png";